import React, { Suspense } from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { motion, AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'

import Spirits from './Spirits'
import SpiritsRight from './RightPanel'
import SpiritLeft from './LeftPanel'
import BottomActions from './BottomPanel'
import TopSection from './TopPanel'
import InjectSection from './InjectSection'
import { originalVariants, claimedVariants } from './animationVariants'
import { claimSpiritMachineAtom, useStartClaimSpiritMachine } from '@/features/spirit/atoms/claimSpiritMachineAtom'
import { claimSpiritStageAtom } from './atoms/claimSpiritStageAtom'

export const Wrapper = styled.section`
  height: 100vh;
  position: relative;
  overflow: hidden;
`

const ClaimedBg = styled(motion.section)<{url: string}>`
  background-image: url(${(props) => props.url});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width: 100vw;
  position: absolute;
  overflow: hidden;
`

const OriginalBg = styled(motion.section)<{url: string}>`
  background-image: url(${(props) => props.url});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width: 100vw;
  position: absolute;
  overflow: hidden;
`

const PageBackground = () => {
  const machine = useAtomValue(claimSpiritMachineAtom)
  if (!machine.matches('claimed')) {
    return (
      <OriginalBg
        url='/static/images/indexPage/Spirit/step01_img_bg_default.png'
        initial={false}
        exit="exit"
        variants={originalVariants.background}
      />
    )
  }
  return (
    <ClaimedBg
      url='/static/images/indexPage/Spirit/step02_img_bg_default.png'
      // custom={spiritsStatus !== spiritsStatusEnum.claimed ? 0 : 1}
    custom={1}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={claimedVariants.background}
    />
  )
} 

const ClaimSpiritPage: React.FC = () => {
  useStartClaimSpiritMachine()
  const stage = useAtomValue(claimSpiritStageAtom)
  return (
    <section tw="h-screen overflow-hidden relative">
      <PageBackground />
      <AnimatePresence>
        {stage !== 'claimed' && <TopSection />}
      </AnimatePresence>
      <Spirits />
      <Suspense fallback={<div />}>
        <SpiritLeft />
        <SpiritsRight />
        <InjectSection />
        <BottomActions />
      </Suspense>
    </section>
  )
}

export default ClaimSpiritPage
